/* qty-steps.js — incréments multiples Motion (v3.4 : produit ok + drawer bloqué en capture) */
(function () {
  const $ = (s, r) => (r && r.querySelector ? r : document).querySelector(s);
  const $$ = (s, r) =>
    Array.from(((r && r.querySelectorAll) ? r : document).querySelectorAll(s));

  /* helpers config fiche produit */
  function readCfg() {
    try {
      const el = document.getElementById('variant-steps-json');
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      return null;
    }
  }

  function formFromInput(input) {
    if (!input) return null;
    const id = input.getAttribute && input.getAttribute('form');
    return id ? document.getElementById(id) : (input.closest ? input.closest('form') : null);
  }

  function currentVariantId(input) {
    const f = formFromInput(input);
    if (!f) return null;
    const hid = f.querySelector('[name="id"]');
    if (hid && hid.value) return hid.value;
    const sel = f.querySelector('[data-product-select] select');
    return sel && sel.value ? sel.value : null;
  }

  function findInput(wrapper) {
    return wrapper.querySelector(
      'input[name="updates[]"], input[name="quantity"], .js-qty__num, .cart__qty-input, input[type="number"], input[type="text"]'
    );
  }

  /* steps */
  function stepFromDataset(node) {
    const holder = node.closest('[data-step],[data-qty-step]');
    if (!holder) return null;
    const raw = holder.getAttribute('data-step') || holder.getAttribute('data-qty-step');
    const v = parseInt(raw, 10);
    return v > 0 ? v : null;
  }

  function stepOnProduct(wrapper) {
    const cfg = readCfg();
    if (cfg) {
      const input = findInput(wrapper);
      const vid = currentVariantId(input);
      const byVar = (vid && cfg.variants && cfg.variants[vid]) ? Number(cfg.variants[vid]) : null;
      const byProd = (cfg.productStep != null) ? Number(cfg.productStep) : null;
      return (byVar && byVar > 0) ? byVar : (byProd && byProd > 0) ? byProd : (stepFromDataset(wrapper) || 1);
    }
    return stepFromDataset(wrapper) || 1;
  }

  function stepOnCart(wrapper) {
    return stepFromDataset(wrapper) || 1;
  }

  const isProductPage = () => !!document.getElementById('variant-steps-json');
  const getStep = (w) => isProductPage() ? stepOnProduct(w) : stepOnCart(w);

  function norm(val, step) {
    let n = parseInt(val, 10);
    if (isNaN(n) || n < step) n = step;
    return Math.ceil(n / step) * step;
  }

  /* nos contrôles (on cache ceux du thème) */
  function ensureOwnControls(wrapper, context) {
    if (!wrapper || wrapper.__qtyxOwn) return;
    wrapper.__qtyxOwn = true;

    const input = findInput(wrapper);
    if (!input) return;

    // layout propre
    wrapper.style.display = 'inline-flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.gap = '8px';

    // masque les boutons natifs du thème
    wrapper.querySelectorAll('.js-qty__adjust').forEach(b => {
      b.style.display = 'none';
    });

    // supprime d’éventuels anciens boutons
    wrapper.querySelectorAll('.qtyx-btn').forEach(el => el.remove());

    // crée [−] input [+]
    const minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'qtyx-btn qtyx-minus';
    minus.setAttribute('aria-label', 'diminuer');
    minus.textContent = '−';

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'qtyx-btn qtyx-plus';
    plus.setAttribute('aria-label', 'augmenter');
    plus.textContent = '+';

    const before = input.previousElementSibling;
    input.insertAdjacentElement('beforebegin', minus);
    input.insertAdjacentElement('afterend', plus);

    // init valeur/min
    const st = getStep(wrapper);
    input.value = norm(input.value || 1, st);
    input.setAttribute('min', st);

    const doMinus = () => {
      const step = getStep(wrapper);
      let cur = parseInt(input.value, 10);
      if (isNaN(cur)) cur = step;
      const k = Math.ceil(cur / step);
      const next = Math.max(step, (k - 1) * step);
      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const doPlus = () => {
      const step = getStep(wrapper);
      let cur = parseInt(input.value, 10);
      if (isNaN(cur)) cur = step;
      const next = norm(cur + step, step);
      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    minus.addEventListener('click', (e) => {
      doMinus();
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    });

    plus.addEventListener('click', (e) => {
      doPlus();
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    });

    input.addEventListener('blur', () => {
      const v = norm(input.value, getStep(wrapper));
      if (String(v) !== String(input.value)) {
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    if (context === 'product') {
      const f = formFromInput(input);
      const vEl = f && (f.querySelector('[name="id"]') || f.querySelector('[data-product-select] select'));
      if (vEl) {
        vEl.addEventListener('change', () => {
          const st2 = getStep(wrapper);
          input.setAttribute('min', st2);
          const v = norm(input.value, st2);
          if (String(v) !== String(input.value)) {
            input.value = v;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }
  }

  function wireProduct() {
    $$('.product__quantity .js-qty__wrapper').forEach(w => ensureOwnControls(w, 'product'));
  }

  function wireCartAndDrawer() {
    $$('.js-qty__wrapper').forEach(w => ensureOwnControls(w, 'cart'));
  }

  /* —— drawer : blocage CAPTURE de tous les clics dans la zone quantité —— */
  function lockDrawerClicks() {
    const form = $('[data-location="cart-drawer"]');
    if (!form || form.__qtyxLocked) return;
    form.__qtyxLocked = true;

    const handler = (e) => {
      const wrap = e.target && e.target.closest('.cart__item--qty, .js-qty__wrapper');
      if (!wrap || !form.contains(wrap)) return;

      const w = wrap.closest('.js-qty__wrapper') || wrap.querySelector('.js-qty__wrapper');
      if (!w) return;

      const input = findInput(w);
      if (!input) return;

      const isOurMinus = !!e.target.closest('.qtyx-minus');
      const isOurPlus = !!e.target.closest('.qtyx-plus');

      if (isOurMinus || isOurPlus) {
        // nos boutons : on gère et on bloque TOUT le thème
        if (isOurMinus) {
          const step = getStep(w);
          let cur = parseInt(input.value, 10);
          if (isNaN(cur)) cur = step;
          const k = Math.ceil(cur / step);
          const next = Math.max(step, (k - 1) * step);
          input.value = next;
        } else {
          const step = getStep(w);
          let cur = parseInt(input.value, 10);
          if (isNaN(cur)) cur = step;
          input.value = norm(cur + step, step);
        }
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return;
      }

      // autres clics (ex: clic sur anciens boutons restés dans le DOM, molette, etc.)
      // on laisse faire le thème, PUIS on corrige immédiatement derrière.
      setTimeout(() => {
        const step = getStep(w);
        const fixed = norm(input.value, step);
        if (String(fixed) !== String(input.value)) {
          input.value = fixed;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 0);
    };

    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(evt => {
      form.addEventListener(evt, handler, { capture: true });
    });
  }

  /* drawer : pompe pour (ré)insérer nos contrôles pendant les réinjections ajax */
  let drawerPumpId = null;

  function pumpDrawer() {
    const form = $('[data-location="cart-drawer"]');
    if (!form) return;
    const list = form.querySelector('[data-products]') || form;

    clearInterval(drawerPumpId);
    let tries = 0;

    drawerPumpId = setInterval(() => {
      const wraps = $$('.js-qty__wrapper', list);
      wraps.forEach(w => ensureOwnControls(w, 'cart'));

      if (wraps.length && wraps.every(w => w.querySelector('.qtyx-btn'))) {
        clearInterval(drawerPumpId);
      }
      if (++tries > 30) clearInterval(drawerPumpId);
    }, 120);
  }

  function run() {
    wireProduct();
    wireCartAndDrawer();
    lockDrawerClicks();
    pumpDrawer();
  }

  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });


// Ajout d'un libellé de quantité (lecture seule) + lien "modifier la quantité dans le panier"
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-location="cart-drawer"]');
  if (!form) return;

  const renderItem = (item) => {
  const detailsEl = item.querySelector('.cart__item--details');
  if (!detailsEl) return;

  // 1) lis la quantité depuis l'input (même s'il est masqué)
  const input = item.querySelector('input[name="updates[]"], .js-qty__num, .cart__qty-input');
  const qty = input ? (parseInt(input.value, 10) || 0)
                    : ((parseInt(item.getAttribute('data-quantity'), 10)) || 0);

  // 2) cible la zone prix du drawer
  const priceEl = detailsEl.querySelector('.cart__item--price');
  // crée/garantit un conteneur flex pour avoir: [quantité readonly] ... [prix]
  let row = detailsEl.querySelector('.qty-price-row');
  if (!row) {
    row = document.createElement('div');
    row.className = 'qty-price-row';
    // insère la row juste avant la zone prix (ou en tête si pas trouvée)
    detailsEl.insertBefore(row, priceEl || detailsEl.firstChild);
  }

  // si le prix n'est pas déjà dans la row, déplace-le dedans (on conserve ses classes)
  if (priceEl && priceEl.parentElement !== row) {
    row.appendChild(priceEl);
  }

  // 3) crée/maj la pastille lecture seule "quantité : X" à gauche (dans la row)
  let ro = row.querySelector('.qty-readonly');
  if (!ro) {
    ro = document.createElement('div');
    ro.className = 'qty-readonly';
    // on place la quantité AVANT le prix pour qu’elle soit à gauche
    row.insertBefore(ro, row.firstChild);
  }
ro.innerHTML = `<span class="qty-readonly__label">Quantité&nbsp;:</span> <span class="qty-readonly__value">${qty}</span>`;

  // 4) le lien "modifier..." dans un conteneur dédié sous la row (pas dans la même ligne)
let hintWrap = detailsEl.querySelector('.qty-hint-wrap');
if (!hintWrap) {
  hintWrap = document.createElement('div');
  hintWrap.className = 'qty-hint-wrap';
  // insère APRES la row (pour forcer une ligne complète)
  if (row && row.nextSibling) {
    detailsEl.insertBefore(hintWrap, row.nextSibling);
  } else {
    detailsEl.appendChild(hintWrap);
  }
}

// s'il existe déjà un lien en vrac, on le déplace dans le wrap
let link = detailsEl.querySelector('.qty-hint');
if (!link) {
  link = document.createElement('a');
  link.href = '/cart';
  link.className = 'qty-hint';
  link.textContent = 'Modifier la quantité dans le panier';
}
if (link.parentElement !== hintWrap) {
  hintWrap.appendChild(link);
}

};

  const renderAll = () => {
    form.querySelectorAll('.cart__item').forEach(renderItem);
  };

  // coalesce pour ne pas gêner le JS du thème
  let rafId = null;
  const scheduleRender = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      renderAll();
    });
  };

  // observe les réinjections du drawer
  const mo = new MutationObserver(scheduleRender);
  mo.observe(form, { childList: true, subtree: true });

  // se resynchronise si la quantité change côté thème
  form.addEventListener('input',  (e)=>{ if (e.target && e.target.name === 'updates[]') scheduleRender(); }, true);
  form.addEventListener('change', (e)=>{ if (e.target && e.target.name === 'updates[]') scheduleRender(); }, true);

  // premier rendu
  scheduleRender();
});


  // relance à l’ouverture du drawer
  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-drawer-open, .drawer__close-button, [data-action="open-drawer"], .site-header__cart, [href="/cart"]')) {
      setTimeout(() => {
        lockDrawerClicks();
        pumpDrawer();
      }, 60);
    }
  });

  window.__qtySteps = {
    version: '3.4',
    drawerReady: () =>
      Array.from(document.querySelectorAll('[data-location="cart-drawer"] .js-qty__wrapper'))
        .map(w => !!w.querySelector('.qtyx-btn'))
  };
})();